import React from "react";

import { Alert } from "../UI";
import { HelperUtils } from "../../services";
import { TranslationMixin } from "tds_shared_ui";
import { WithCommonTranslations } from "./../hocs";
import { PlaceOrderForm } from "./PlaceOrderForm";
import { WithLMSTranslations } from "../hocs";

export const PlaceOrder = WithCommonTranslations(
  WithLMSTranslations(
    class extends TranslationMixin(React.Component) {
      constructor(props) {
        super(props);
        this.alertRef = React.createRef();

        this.state = {
          loading: false,
          disabled: true,
          paymentWidget: null,
          validationErrors: false,
          alert: {
            display: false,
            type: "default",
            message: "",
          },
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.onValidationError = this.onValidationError.bind(this);
        this.handlePaymentInit = this.handlePaymentInit.bind(this);
        this.handlePaymentSuccess = this.handlePaymentSuccess.bind(this);
        this.handlePaymentError = this.handlePaymentError.bind(this);
      }

      scrollToAlert() {
        HelperUtils.scrollToAlert(this.alertRef);
      }

      onValidationError() {
        this.setState({
          validationErrors: true,
        });
        this.showFormError();
        this.submitPaymentWidget();
      }

      handleSubmit() {
        this.setState({
          validationErrors: false,
          loading: true,
          alert: {
            display: false,
          },
        });
        this.submitPaymentWidget();
      }

      handlePaymentInit(widget) {
        if (widget === null) {
          this.setState(
            {
              disabled: true,
              alert: {
                display: true,
                message: this.getTranslation("ERROR_PAYMENT_FORM_DOWN"),
                type: "error",
              },
            },
            this.scrollToAlert
          );
        } else {
          this.setState({
            paymentWidget: widget,
            disabled: false,
          });
        }
      }

      handlePaymentSuccess(data) {
        if (data.response.sessionId) {
          this.props.setPaymentInfo(data.response);
        }

        if (!this.state.validationErrors) {
          this.props.onNext();
        } else {
          this.setState({
            loading: false,
          });
        }
      }

      handlePaymentError(error) {
        console.log(error);
        this.setState({
          loading: false,
        });

        this.showFormError();
      }

      showFormError() {
        this.setState(
          {
            alert: {
              display: true,
              message: this.getTranslation("ERROR_FORM_VALIDATION"),
              type: "error",
            },
          },
          this.scrollToAlert
        );
      }

      submitPaymentWidget() {
        let pay = this.state.paymentWidget;
        if (pay !== null) {
          this.state.paymentWidget.submit();
        } else {
          this.setState({
            loading: false,
          });
        }
      }

      render() {
        return (
          <div className="checkout-place-order">
            {this.state.alert.display && (
              <Alert ref={this.alertRef} type={this.state.alert.type}>
                {this.state.alert.message}
              </Alert>
            )}

            <p>{this.getTranslation("MESSAGE_PLACE_ORDER_HELP")}</p>

            <PlaceOrderForm
              submit={this.handleSubmit}
              loading={this.state.loading || this.props.loading}
              disabled={this.state.disabled}
              onValidationError={this.onValidationError}
              onPaymentInit={this.handlePaymentInit}
              onPaymentSuccess={this.handlePaymentSuccess}
              onPaymentError={this.handlePaymentError}
              onCancel={this.props.onCancel}
              {...this.props}
            />
          </div>
        );
      }
    }
  )
);
